'use client';

import { Select, SelectContent, SelectItem } from '@packages/shared/src/ui/Select/Select';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useIntl } from 'react-intl';
import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { CustomerReviewsSort } from './getSortParams';

export const SortSelection = () => {
  const { formatMessage } = useIntl();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { language, localizeUrl } = useI18n();
  const { push } = useRouter();

  const sortParam = searchParams?.get('sort');
  const sort = sortParam ? decodeURIComponent(sortParam) : CustomerReviewsSort.NEWEST;

  const onValueChangeHandler = (value: string) => {
    const newSearchParams = new URLSearchParams(searchParams?.toString());

    newSearchParams.set('sort', value);
    if (newSearchParams.get('page')) {
      newSearchParams.set('page', '1');
    }

    push(localizeUrl(`${pathname}?${newSearchParams.toString()}`, language), { scroll: false });
  };

  return (
    <div className="md:max-w-[21.438rem]">
      <Select
        label={formatMessage({
          id: 'CustomerRatingsAndReviewsPage.sort.sortSelection.label',
          defaultMessage: 'Sortieren nach',
        })}
        value={sort}
        onValueChange={onValueChangeHandler}
      >
        <SelectContent>
          <SelectItem value={CustomerReviewsSort.NEWEST}>
            {formatMessage({
              id: 'CustomerRatingsAndReviewsPage.sort.sortSelection.newest',
              defaultMessage: 'Neueste Zuerst',
            })}
          </SelectItem>
          <SelectItem value={CustomerReviewsSort.OLDEST}>
            {formatMessage({
              id: 'CustomerRatingsAndReviewsPage.sort.sortSelection.oldest',
              defaultMessage: 'Älteste Zuerst',
            })}
          </SelectItem>
          <SelectItem value={CustomerReviewsSort.BEST}>
            {formatMessage({
              id: 'CustomerRatingsAndReviewsPage.sort.sortSelection.best',
              defaultMessage: 'Positivste Zuerst',
            })}
          </SelectItem>
          <SelectItem value={CustomerReviewsSort.WORST}>
            {formatMessage({
              id: 'CustomerRatingsAndReviewsPage.sort.sortSelection.worst',
              defaultMessage: 'Negativste Zuerst',
            })}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
